import styles from "../../styles/common/Alert.module.scss"

import {ReactNode} from "react";
import clsx from "clsx";

import {cStatusProps} from "../../utils";

interface AlertProps extends cStatusProps{
  extraClassName?: string;
  alertStyle?: "bordered"; // like badge
  alertRadius?: "rounded12px"; //default radius is 50em
  icon?: ReactNode;
}
function Alert(
  {
    extraClassName,
    type,
    alertStyle,
    alertRadius,
    icon,
    text,
    children,
  }: AlertProps) {
  return (
    <aside
      className={clsx(styles.cAlert, "c-alert", extraClassName && extraClassName)}
      data-alert-type={type}
      data-alert-style={alertStyle}
      data-alert-radius={alertRadius}
    >
      {icon && (
        <i>
          {icon}
        </i>
      )}

      {text? text : children}

    </aside>
  );
}

export default Alert;